import { GraduationCap, MessagesSquare } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { ClassRoomsPage } from '@/pages/messaging/ClassRoomsPage'
import { MessagesPage } from '@/pages/messaging/MessagesPage'
import type { AppModule } from '../moduleRegistry'

const messages = [
  { path: 'messages', element: <MessagesPage /> },
  { path: 'messages/:conversationId', element: <MessagesPage /> },
]
const withRooms = [...messages, { path: 'messages/class-rooms', element: <ClassRoomsPage /> }]
const keywords = 'chat conversations messaging calls video audio class rooms live class'

export const module: AppModule = {
  id: 'messaging',
  schoolModule: 'messaging',
  routes: {
    admin: [{ element: <RequirePermission permission="messaging.use" />, children: withRooms }],
    staff: [{ element: <RequirePermission permission="messaging.use" />, children: withRooms }],
    family: [{ element: <RequirePermission permission="messaging.use" />, children: messages }],
  },
  nav: {
    admin: [
      {
        group: 'Communication',
        order: 5,
        item: {
          label: 'Messages',
          to: '/admin/messages',
          icon: MessagesSquare,
          permission: 'messaging.use',
          keywords,
          end: true,
        },
      },
      {
        group: 'Communication',
        order: 6,
        item: {
          label: 'Class rooms',
          to: '/admin/messages/class-rooms',
          icon: GraduationCap,
          permission: 'messaging.manage',
          keywords: 'class rooms live class sections',
        },
      },
    ],
    staff: [
      {
        order: 12,
        item: {
          label: 'Messages',
          to: '/staff/messages',
          icon: MessagesSquare,
          permission: 'messaging.use',
          keywords,
        },
      },
    ],
    family: [
      {
        order: 12,
        item: {
          label: 'Messages',
          to: '/portal/messages',
          icon: MessagesSquare,
          permission: 'messaging.use',
          keywords,
        },
      },
    ],
  },
}
